// extracted by mini-css-extract-plugin
export default {"root":"Ingredients_root__bZaND","header":"Ingredients_header__L012V","title":"Ingredients_title__7ZY4F"};